import React, { memo } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { FaThumbsUp, FaBan } from "react-icons/fa";
import { Icon, Tooltip, Text } from "@chakra-ui/react";

const ApproverInfo = ({ approvedBy, rejectedBy, showName, ...rest }) => {
  const { t } = useTranslation("planner");

  if (approvedBy) {
    return (
      <Tooltip
        label={t("drafts.approved_by", {
          name: approvedBy.name,
        })}
        placement="top"
        hasArrow
      >
        <Text
          d="flex"
          alignItems="center"
          fontWeight="normal"
          fontSize="xs"
          {...rest}
        >
          <Icon fontSize="xs" as={FaThumbsUp} color="brand.positive" mr="2" />
          <Text as="span" ml="1" display={["none", "none", "inline-block"]}>
            {approvedBy.name}
          </Text>
        </Text>
      </Tooltip>
    );
  }

  if (rejectedBy) {
    return (
      <Tooltip
        label={t("drafts.rejected_by", {
          name: rejectedBy.name,
        })}
        placement="top"
        hasArrow
      >
        <Text
          d="flex"
          alignItems="center"
          fontWeight="normal"
          fontSize="xs"
          {...rest}
        >
          <Icon fontSize="xs" as={FaBan} color="brand.negative" mr="2" />
          <Text as="span" display={["none", "none", "inline"]}>
            {rejectedBy.name}
          </Text>
        </Text>
      </Tooltip>
    );
  }

  return null;
};

ApproverInfo.propTypes = {
  approvedBy: PropTypes.object,
  rejectedBy: PropTypes.object,
};

ApproverInfo.defaultProps = {
  approvedBy: undefined,
  rejectedBy: undefined,
};

export default memo(ApproverInfo);
